var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3828 0 0 5.3828 0 12C0 18.6172 5.3828 24 12 24C18.6172 24 24 18.6163 24 12C24 5.38373 18.6172 0 12 0ZM12 22.141C6.40898 22.141 1.85902 17.592 1.85902 12C1.85902 6.40805 6.40898 1.85902 12 1.85902C17.592 1.85902 22.141 6.40805 22.141 12C22.141 17.592 17.591 22.141 12 22.141Z",
    fill: "#17B67C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5077 7.82692C17.1294 7.483 16.541 7.50996 16.1952 7.89011L10.5252 14.1337L7.78589 11.3489C7.42429 10.9826 6.83686 10.9771 6.47156 11.3377C6.10532 11.6974 6.09974 12.2858 6.4604 12.652L9.88936 16.1377C10.065 16.3162 10.303 16.4156 10.5521 16.4156C10.5577 16.4156 10.5642 16.4156 10.5698 16.4166C10.8263 16.411 11.068 16.3013 11.2399 16.1117L17.5708 9.14036C17.9157 8.75922 17.8878 8.17178 17.5077 7.82692Z",
    fill: "#17B67C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/successMark.c5446221e46828aaf1453ad998db53c6.svg";
export { ForwardRef as ReactComponent };